import React, { useState,useEffect } from "react";
import axios from 'axios'
import Room from "../components/Room";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Error from "../components/Error";
import { DatePicker, Space } from "antd";
const { RangePicker } = DatePicker;



const Home = () => {
const [roooms,setrooms]= useState([])
const [loading,setloading]= useState()
const [type, settype] = useState('all');
const [error, seterror] = useState();
const [searchkey, setsearchkey] = useState('');
const [duplicateroom,setduplicateroom] = useState([])
const [todate, settodate] = useState();
const [fromdate, setfromdate] = useState();
const navigate = useNavigate();
    useEffect(() => {
		if (!localStorage.getItem("currentuser")) {
			navigate("/login");
		}
		try {
			setloading(true)
	axios.get("https://online-hotels-booking-system-server.vercel.app/api/rooms/getallrooms").then((response) => {
		
		setrooms(response.data);
		setduplicateroom(response.data)
		setloading(false)
		
	});
} catch (error) {
	seterror(true)
	setloading(false);
}

		}, []); 

		const filterByDate = (dates) =>{
			setfromdate((dates[0]).format("DD-MM-YYYY"));
			settodate((dates[1]).format("DD-MM-YYYY"));

				var temroom =[]
				var availability = false
				for(const room of duplicateroom){
				if(room.currentbookings.length>0){
					for(const booking of room.currentbookings){
						if (
							!moment(dates[0].format("DD-MM-YYYY")).isBetween(
								booking.fromdate,
								booking.todate
							) &&
							!moment(dates[1].format("DD-MM-YYYY")).isBetween(
								booking.fromdate,
								booking.todate
							)
						) {
							if (
								dates[0].format("DD-MM-YYYY") !== booking.fromdate &&
								dates[0].format("DD-MM-YYYY") !== booking.todate &&
								dates[1].format("DD-MM-YYYY") !== booking.fromdate &&
								dates[1].format("DD-MM-YYYY") !== booking.todate
							) {
								availability= true
							}
						}
					}
				}
if(availability ===  true || room.currentbookings.length===0){
	temroom.push(room)
}
setrooms(temroom)
		}
		}

function filterBySearch(){
const temprooms = duplicateroom.filter((room) =>
	room.name.toLowerCase().includes(searchkey.toLowerCase())
);
setrooms(temprooms)
}

function filterByTypr(e){
	settype(e)
if(e !== 'all'){
const temprooms = duplicateroom.filter((room) =>
	room.type.toLowerCase() == e.toLowerCase());
	setrooms(temprooms)
}else{
	setrooms(duplicateroom)
}
}
	return (
		<div className="container">
			<div className="row mt-5 bs">
				<div className="col-md-3">
					<RangePicker format="DD-MM-YYYY" onChange={filterByDate} />
				</div>
				<div className="col-md-5">
					<input
						type="text"
						placeholder="search room"
						className="form-control "
						value={searchkey}
						onChange={(e) => {
							setsearchkey(e.target.value);
						}}
						onKeyUp={filterBySearch}
					/>
				</div>

				<div className="col-md-3">
					<select
						className="form-control"
						value={type}
						onChange={(e) => {
							filterByTypr(e.target.value);
						}}>
						<option value="all">All</option>
						<option value="delux">Delux</option>
						<option value="non-delux">Non-Delux</option>
						<option value="Suite">Suite</option>
						<option value="Double">Double</option>
						<option value="Single">Single</option>
					
					</select>
				</div>
			</div>

			<div className="row justify-content-center mt-5">
				{loading ? (
					<Loader />
				) : (
					roooms.map((room) => {
						return (
							<div className="col-md-9 mt-2">
								<Room room={room} fromdate={fromdate} todate={todate} />
							</div>
						);
					})
				)}
			</div>
		</div>
	);
};

export default Home;
